import { FormattedMessage } from '@flipster/i18n';
import { Badge } from '@flipster/react/design-system/badge';
import { css } from '@flipster/styled-system/css';
import { center, circle, hstack, stack, vstack } from '@flipster/styled-system/patterns';

export const ComingSoonCard = () => {
  return (
    <div
      className={stack({
        gap: 20,
        p: 16,
        borderWidth: '1px',
        borderStyle: 'dashed',
        borderColor: 'border.default.level-1',
        rounded: 8,
      })}
    >
      <div
        className={center({
          flex: 1,
        })}
      >
        <div className={vstack({ gap: 10 })}>
          <Badge type='outline' color='neutral'>
            <FormattedMessage id='Common.r251028.Coming_soon' />
          </Badge>
          <p
            className={css({
              textStyle: 'Title/XS',
              color: 'content.default.level-5',
              textAlign: 'center',
            })}
          >
            <FormattedMessage id='Earn.r251204.More_products_on_way' />
          </p>
        </div>
      </div>
      <div
        className={vstack({
          gap: 6,
          py: 12,
          px: 16,
          rounded: 8,
          bg: 'background.default.level-1',
        })}
      >
        <p
          className={css({
            textStyle: 'Text/S/Regular',
            color: 'content.default.level-2',
          })}
        >
          <FormattedMessage id='Autogen_common.r251126.s_APR_app' />
        </p>
        <div
          className={hstack({
            gap: 8,
          })}
        >
          <div className={hstack({ gap: 4 })}>
            <span
              className={circle({
                size: 12,
                bg: 'background.state.positive.tint',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'border.state.positive',
              })}
            />
            <span
              className={circle({
                size: 12,
                bg: 'background.state.positive.tint',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'border.state.positive',
              })}
            />
            <span
              className={circle({
                size: 12,
                bg: 'background.state.positive.tint',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'border.state.positive',
              })}
            />
          </div>
          <p
            className={css({
              textStyle: 'Title/S/Monospace',
              color: 'content.state.positive',
            })}
          >
            %
          </p>
        </div>
      </div>
    </div>
  );
};
